/*
 * Created by clopez on 17/12/2024.
 */
angular.module('annexaApp')
	.directive('annexaBoxAddressIdentificationReferencesTerritory', ['$compile', 'Language', function ($compile, Language) {
        var getTemplate = function(scope, languageColumn) {
            var template = '';

            template += '<div ng-if="addressIdentificationReferences.length==0" class="text-center cursiva-grey" translate="global.territory.list.emptyIdentificationReferences">Add</div>';

            template += '<div ng-if="addressIdentificationReferences.length>0">';
            template += '   <div class="row ng-class:{\'m-b-p-b-sm-b-b\' : !$last}" ng-repeat="addressIdentificationReference in addressIdentificationReferences" >';
            template += '       <div class="col-xs-11">';
            template += '           <div class="row m-b-xs ">';
            template += '               <div class="col-xs-3">';
            template += '                   <span>{{ addressIdentificationReference.addressIdentificationReferenceType[languageColumn] }}</span>';
            template += '               </div>';
            template += '               <div class="col-xs-4">';
            template += '                   <span>{{ addressIdentificationReference.identificationReference }}</span>';
            template += '               </div>';
            template += '           </div>';
            template += '       </div>';
            template += '       <div ng-if="editFunction" class="col-xs-1" permission permission-only="permissions">';
            template += '           <annexa-edit-button edit-function="editFunction" edit-object="addressIdentificationReference" edit-object-index="$index" actual="true" class="pull-right"></annexa-edit-button>';
            template += '       </div>';
            template += '       <div class="col-xs-1" permission permission-only="permissions">';
            template += '           <annexa-delete-button delete-function="deleteFunction" delete-object="addressIdentificationReference" delete-object-index="$index" actual="true" class="pull-right"></annexa-delete-button>';
            template += '       </div>';
            template += '   </div>';
            template += '</div>';

            return template;
        };

        return {
            restrict: 'E',
            replace: true,
            scope: {
                addressIdentificationReferences: '=',
                deleteFunction: '=',
                editFunction: '=',
                permissions: '='
            },
            link: function (scope, element, attr) {
                scope.languageColumn = Language.getActiveColumn();

                element.html(getTemplate(scope, scope.languageColumn)).show();

                $compile(element.contents())(scope);
            }
        };
    }])